import React from 'react';
import { Text, TextInput, TouchableOpacity, View } from 'react-native';
import { ticketColors } from '../../shared/theme/ticketColors';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';
import type { CatalogProductFormFieldsProps } from './catalogProductFormFields.types';

type Props = Pick<
  CatalogProductFormFieldsProps,
  | 'draft'
  | 'onOpenSupplierPicker'
  | 'supplierOptions'
  | 'onSupplierItemCodeChange'
  | 'mobile'
  | 'desktopRail'
>;

export function CatalogProductFormOrganizationFields({
  draft,
  onOpenSupplierPicker,
  supplierOptions = [],
  onSupplierItemCodeChange,
  mobile = false,
  desktopRail = false,
}: Props) {
  const supplierLabel = draft.preferredSupplierId
    ? supplierOptions.find((s) => s.id === draft.preferredSupplierId)?.name ?? 'Proveedor'
    : 'Elegir…';

  return (
    <View style={styles.ticketFormSection}>
      {!desktopRail ? <Text style={styles.ticketFormSectionTitle}>Proveedor</Text> : null}
      {/* Proveedor + Código del proveedor: grid on desktop, stack on mobile */}
      <View style={mobile ? styles.fieldGridMobile : styles.fieldGrid}>
        <View style={[styles.ticketFormField, !mobile && styles.fieldGridItem]}>
          <Text style={styles.ticketFormLabel}>Proveedor</Text>
          <TouchableOpacity
            style={[
              styles.ticketFormInput,
              styles.pickerTrigger,
              !!draft.preferredSupplierId && styles.pickerTriggerActive,
            ]}
            onPress={onOpenSupplierPicker}
            accessibilityRole="button"
            accessibilityLabel="Elegir proveedor"
          >
            <Text
              style={[
                styles.pickerTriggerText,
                !draft.preferredSupplierId && styles.pickerTriggerTextMuted,
              ]}
              numberOfLines={1}
            >
              {supplierLabel}
            </Text>
            <Text style={styles.pickerTriggerChev}>▾</Text>
          </TouchableOpacity>
        </View>
        <View style={[styles.ticketFormField, !mobile && styles.fieldGridItem]}>
          <Text style={styles.ticketFormLabel}>Código del proveedor</Text>
          <TextInput
            style={styles.ticketFormInput}
            value={draft.supplierItemCode}
            onChangeText={onSupplierItemCodeChange ?? (() => {})}
            placeholder="El código que usa el proveedor"
            placeholderTextColor={ticketColors.ink3}
            autoCapitalize="characters"
          />
        </View>
      </View>
    </View>
  );
}

export function CatalogProductFormNotesFields({
  draft,
  onInternalNotesChange,
  desktopRail = false,
}: Pick<CatalogProductFormFieldsProps, 'draft' | 'onInternalNotesChange' | 'desktopRail'>) {
  return (
    <View style={styles.ticketFormSection}>
      {!desktopRail ? <Text style={styles.ticketFormSectionTitle}>Notas internas</Text> : null}
      <View style={styles.ticketFormField}>
        <TextInput
          style={[styles.ticketFormInput, styles.notesMultiline]}
          value={draft.internalNotes}
          onChangeText={onInternalNotesChange ?? (() => {})}
          placeholder="Solo lo ves vos. No sale en el mostrador."
          placeholderTextColor={ticketColors.ink3}
          multiline
        />
      </View>
    </View>
  );
}
